import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-8 md:py-16 px-4 bg-brand-dark border-y-4 border-brand-green" data-id="element-146">
      <div className="max-w-4xl mx-auto text-center" data-id="element-147">
        <img src="https://cdn.magicpatterns.com/uploads/oxeBghMG4kWvsdJc5N5Pg5/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-24 h-24 md:w-40 md:h-40 mx-auto mb-3 md:mb-5 object-contain" data-id="element-148" />

        <h2 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6 uppercase" data-id="element-149">
          🛡️ Garantía de Satisfacción Total — 30 Días
        </h2>

        <div className="text-xl md:text-2xl text-gray-300 space-y-2 md:space-y-3 font-medium mb-6 md:mb-10 max-w-3xl mx-auto" data-id="element-150">
          <p data-id="element-151">
            Probalo 30 días completos. Si por cualquier motivo no recuperás
            tiempo con el sistema, te devolvemos el 100% de tu inversión.
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-green py-2 md:py-4" data-id="element-152">
            Sin preguntas incómodas. Sin vueltas.
          </p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-153">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-154" />
        </div>
      </div>
    </section>;
}